import { HStack, Text, Separator } from "@chakra-ui/react";


const SeparatorText = ({ text }: { text: string }) => 
(<HStack w='90%'>
    <Separator flex="1" />
    <Text color='gray.500' flexShrink="0">{text}</Text>
    <Separator flex="1" />
</HStack>)

export default SeparatorText;